<div *ngIf="detailData" class="drawer-detail {{containerCss}} drawer-detail-{{cardIndex}}"
    [id]="id"
    [ngClass]="{'show': show}"
    role="region"
    [attr.aria-labelledby]="groupId"
    [attr.aria-expanded]="show">

    <h4 *ngIf="detailData.viewMoreTitle"
        [id]="drawerTitleId"
        class="drawer-title"
        tabindex="-1"
        [innerHTML]="detailData.viewMoreTitle | safeHtml">
    </h4>
    <div class="drawer-text" [ngClass]="{'column-reverse': detailData?.viewMoreMedia}">
        <div *ngIf="detailData.viewMoreMedia" class="media">
            <img [src]="detailData.viewMoreMedia.mobile" [alt]="detailData.viewMoreMedia.alt">
        </div>
        <div class="dynamic-html">
            <div [innerHTML]="detailData.viewMoreSubtitle | safeHtml"></div>
            <finder-disclaimer *ngIf="detailData.viewMoreDisclaimer"
                [disclaimer]="detailData.viewMoreDisclaimer"
            ></finder-disclaimer>
            <p *ngIf="enableTop">
                <a href="#"
                    (click)="click($event, true)"
                    aria-label="Top">^&nbsp;{{detailData.topLink}}</a>
            </p>
        </div>
    </div>
    <div class="drawer-less">
        <button class="drawer-close"
            (click)="click($event);"
            [attr.aria-label]="ariaLabelClose">
            <finder-font-icon
                size="inherit"
                name="previous"
                class="icon-previous"
            ></finder-font-icon>
            <finder-font-icon
                size="inherit"
                name="close-button"
                class="icon-close"
            ></finder-font-icon>
        </button>
    </div>
</div>
